if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
        this.parentElement.addEventListener("shopify:section:select", () => this.open());
        this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains("is--open")) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.querySelector(
        ".quick-cart-drawer__backdrop"
      ).addEventListener("click", this.close.bind(this));

      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", e => {
        if (e.key === "Escape" && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement =
            focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === "Tab";

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document
          .querySelectorAll(".quick-cart-drawer__trigger")
          .forEach(element => {
            if (!element._init) {  
              element.addEventListener("click", event => {
                this.fetchProductForQuickCartDrawer(event);
              });
              element._init = true; 
            }
          });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      if (event.target.closest("card-product-slider")) {
        event.target
          .closest("card-product-slider")
          .slider.autoplay.stop();
        event.target
          .closest("card-product-slider")
          .classList.add("product--open-on-quick-cart");
      }

      const isRecommendations = event.target.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      );

      const sourceProductCard = event.target.closest("product-card");
      let productOptions = null;

      if (!isRecommendations) {
        if (!sourceProductCard) return;
        productOptions = sourceProductCard.querySelectorAll(
          'input[type="radio"]:checked, select'
        );
        if (!productOptions || productOptions.length === 0) {
          productOptions = [];
        }
      }

      const trigger = event.target.closest("[data-product-url]");
      if (!trigger) return;
      trigger.classList.toggle("is--loading");
      
      let productCardContainer = null;
      try {
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const productCardResponse = await fetch(
          `${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`
        );
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        productCardContainer = document.createElement("DIV");
        productCardContainer.insertAdjacentHTML("beforeend", productCardHTML);
        if (!productCardContainer.querySelector(".quick-cart-product")) return;
        const drawerMain = this.querySelector(".quick-cart-drawer__main");
        if (!drawerMain) return;
        drawerMain.innerHTML = "";
        const quickCartProduct = productCardContainer.querySelector(".quick-cart-product");
        if (quickCartProduct) {
          drawerMain.append(quickCartProduct);
        }

        this.sliderInstance = new Swiper(".quick-cart-drawer__media-swiper", {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        });
      } catch (error) {
      } finally {
        trigger.classList.toggle("is--loading");

        if (!isRecommendations) {
          productOptions.forEach(productOption => {
            const quickCartDrawerOption = this.querySelector(
              `[name="${productOption.name}"][value="${productOption.value}"]`
            );
            
            if (!quickCartDrawerOption) {
              return;
            }

            const quickCartDrawerOptionLabel = quickCartDrawerOption.parentElement?.parentElement?.querySelector('legend');
            const quickCartDrawerOptionLabelInnerHTML =
              quickCartDrawerOptionLabel?.innerHTML;

            this.querySelectorAll(
              `[name="${productOption.name}"]`
            ).forEach(radioInput => {
              radioInput.removeAttribute("checked");
              const listItem = radioInput.closest("li");
              if (listItem) {
                listItem.classList.remove("checked");
              }
            });

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute("checked", "");
              if (quickCartDrawerOptionLabel) {
                const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
                if (quickCartDrawerOptionLabelSpan) {
                  quickCartDrawerOptionLabelSpan.innerHTML = productOption.value;
                }
              }
            }

            const drawerProductCard = this.querySelector("product-card") || this.querySelector(".quick-cart-product");
            const drawerVariantInput = drawerProductCard?.querySelector('input[name="id"]');
            const cardVariantInput = productCardContainer?.querySelector('input[name="id"]') || sourceProductCard?.querySelector('input[name="id"]');
            
            if (drawerVariantInput && cardVariantInput) {
              drawerVariantInput.value = cardVariantInput.value;
            }

            if (quickCartDrawerOption) {
              const listItem = quickCartDrawerOption.closest("li");
              if (listItem) {
                listItem.classList.add("checked");
              }
            }

            if (drawerProductCard && typeof drawerProductCard.init === 'function') {
              drawerProductCard.init();
            }
          });
        }

        setTimeout(() => {
          this.open();
        }, 500);

        this.querySelector(".quick-cart-drawer__main")
          .querySelectorAll(".variant-option-radio-input")
          .forEach(radioInput => {
            radioInput.addEventListener("change", event => {
              const quickCartDrawerOptionLabel = event.target.parentElement.parentElement.querySelector('legend');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
              }

              const selectedVariantId = (this.querySelector(
                ".product-card__add-to-cart--form input[name='id']"
              ) || this.querySelector(
                ".product-preview-drawer__add-to-cart-form input[name='id']"
              ))?.value;

              const productCardEl = this.querySelector("product-card");
              const productVariantsData = productCardEl?.variantsObj;
              if (productVariantsData) {
                const featuredMedia = productVariantsData.find(
                  variant => variant.id == selectedVariantId
                )?.featured_media;

                if (featuredMedia) {
                  this.setActiveMedia(featuredMedia.id);
                }
              }
            });
          });

        this.bindSiblingColorLinks();
        this.bindSiblingFitLinks();
        this.bindVariantOptionListeners();
      }
    }

    bindVariantOptionListeners() {
      const main = this.querySelector(".quick-cart-drawer__main");
      if (!main) return;

      const variantsScript = main.querySelector("[data-product-variants-json]");
      let variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
      }

      main.querySelectorAll(".product-preview-drawer__fit-option input[type='radio']").forEach(input => {
        if (input._variantBound) return;
        input._variantBound = true;
        input.addEventListener("change", () => {
          main.querySelectorAll(".product-preview-drawer__fit-option").forEach(lbl => {
            lbl.classList.toggle("product-preview-drawer__fit-option--selected", lbl.contains(input));
          });
          this.updateQuickCartSizeAvailability(main, variants);
          this.updateQuickCartVariant(main, variants);
        });
      });

      main.querySelectorAll(".product-preview-drawer__color-option input[type='radio']").forEach(input => {
        if (input._variantBound) return;
        input._variantBound = true;
        input.addEventListener("change", () => {
          main.querySelectorAll("label.product-preview-drawer__color-option").forEach(lbl => {
            lbl.classList.toggle("product-preview-drawer__color-option--selected", lbl.contains(input));
          });
          this.updateQuickCartSizeAvailability(main, variants);
          this.updateQuickCartVariant(main, variants);
        });
      });

      main.querySelectorAll(".product-preview-drawer__size-option input[type='radio']").forEach(input => {
        if (input._variantBound) return;
        input._variantBound = true;
        input.addEventListener("change", () => {
          main.querySelectorAll(".product-preview-drawer__size-option").forEach(lbl => {
            lbl.classList.toggle("product-preview-drawer__size-option--selected", lbl.contains(input));
          });
          this.updateQuickCartVariant(main, variants);
        });
      });

      this.updateQuickCartSizeAvailability(main, variants);
    }

    updateQuickCartVariant(main, variants) {
      if (!variants || variants.length === 0) return;

      const selectedOptions = {};
      main.querySelectorAll("input[type='radio']:checked").forEach(input => {
        const name = input.getAttribute("name");
        if (!name) return;
        const match = name.match(/option\[(\d+)\]/);
        if (match) {
          selectedOptions[match[1]] = input.value;
        }
      });

      const variant = variants.find(v => {
        let matches = true;
        if (selectedOptions["1"] && v.option1 !== selectedOptions["1"]) matches = false;
        if (selectedOptions["2"] && v.option2 !== selectedOptions["2"]) matches = false;
        if (selectedOptions["3"] && v.option3 !== selectedOptions["3"]) matches = false;
        return matches;
      });

      if (variant) {
        const idInput = main.querySelector("input[name='id']");
        if (idInput) idInput.value = variant.id;

        const addToCartBtn = main.querySelector('.product-preview-drawer__add-to-cart-btn');
        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
        }

        const priceElement = main.querySelector('.product-preview-drawer__price');
        if (priceElement && variant.price !== undefined) {
          const price = (variant.price / 100).toFixed(2).replace('.', ',');
          let priceHtml = '';

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const comparePrice = (variant.compare_at_price / 100).toFixed(2).replace('.', ',');
            const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            priceHtml = `
              <div class="price__sale">
                <div class="price__sale-inner">
                  <s>${comparePrice} €</s>
                  <span class="price__discount-badge">-${discount}%</span>
                </div>
                <div class="price__sale-inner">
                  <ins>${price} €</ins>
                </div>
                <div class="price__history">
                  <span class="price__history-text">Prezzo più basso ultimi 30gg: ${comparePrice} €</span>
                </div>
              </div>
            `;
          } else {
            priceHtml = `<div class="price__regular"><span class="price-max">${price} €</span></div>`;
          }
          priceElement.innerHTML = priceHtml;
        }
      } else {
        const addToCartBtn = main.querySelector('.product-preview-drawer__add-to-cart-btn');
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
        }
      }
    }

    updateQuickCartSizeAvailability(main, variants) {
      if (!variants || variants.length === 0) return;

      const selectedNonSize = {};
      main.querySelectorAll("input[type='radio']:checked").forEach(input => {
        const name = input.getAttribute("name");
        if (!name) return;
        const match = name.match(/option\[(\d+)\]/);
        if (!match) return;
        const label = input.closest('label');
        if (label && label.classList.contains('product-preview-drawer__size-option')) return;
        selectedNonSize[match[1]] = input.value;
      });

      let hasSelectedSize = false;
      let selectedSizeStillAvailable = false;

      main.querySelectorAll(".product-preview-drawer__size-option input[type='radio']").forEach(input => {
        const name = input.getAttribute("name");
        if (!name) return;
        const match = name.match(/option\[(\d+)\]/);
        if (!match) return;
        const sizePosition = match[1];
        const sizeValue = input.value;

        const isAvailable = variants.some(v => {
          if (v[`option${sizePosition}`] !== sizeValue) return false;
          if (!v.available) return false;
          for (const [pos, val] of Object.entries(selectedNonSize)) {
            if (v[`option${pos}`] !== val) return false;
          }
          return true;
        });

        input.disabled = !isAvailable;
        const label = input.closest('label');
        if (label) {
          label.classList.toggle('product-preview-drawer__size-option--disabled', !isAvailable);
          if (!isAvailable && input.checked) {
            input.checked = false;
            label.classList.remove('product-preview-drawer__size-option--selected');
          }
          if (input.checked) {
            hasSelectedSize = true;
            selectedSizeStillAvailable = isAvailable;
          }
        }
      });

      if (!hasSelectedSize || !selectedSizeStillAvailable) {
        const firstAvailable = main.querySelector(".product-preview-drawer__size-option input[type='radio']:not(:disabled)");
        if (firstAvailable) {
          firstAvailable.checked = true;
          const label = firstAvailable.closest('label');
          if (label) {
            label.classList.add('product-preview-drawer__size-option--selected');
          }
        }
      }
    }

    bindSiblingColorLinks() {
      const main = this.querySelector(".quick-cart-drawer__main");
      if (!main) return;
      main.querySelectorAll("a.product-preview-drawer__color-option").forEach(link => {
        if (link._siblingBound) return;
        link._siblingBound = true;
        link.addEventListener("click", async (e) => {
          e.preventDefault();
          const siblingUrl = link.getAttribute("href");
          if (!siblingUrl) return;

          const drawerMain = this.querySelector(".quick-cart-drawer__main");
          if (!drawerMain) return;

          try {
            const separator = siblingUrl.includes('?') ? '&' : '?';
            const resp = await fetch(`${siblingUrl}${separator}view=quick-cart`);
            if (!resp.ok) return;
            const html = await resp.text();
            const tmp = document.createElement("DIV");
            tmp.insertAdjacentHTML("beforeend", html);
            const newProduct = tmp.querySelector(".quick-cart-product");
            if (newProduct) {
              drawerMain.innerHTML = "";
              drawerMain.append(newProduct);
              this.bindSiblingColorLinks();
              this.bindSiblingFitLinks();
              this.bindVariantOptionListeners();
            }
          } catch (err) {
            window.location.href = siblingUrl;
          }
        });
      });
    }

    bindSiblingFitLinks() {
      const main = this.querySelector(".quick-cart-drawer__main");
      if (!main) return;
      main.querySelectorAll(".product-preview-drawer__fit-sibling-link").forEach(btn => {
        if (btn._siblingBound) return;
        btn._siblingBound = true;
        btn.addEventListener("click", async (e) => {
          e.preventDefault();
          const siblingUrl = btn.dataset.productUrl;
          if (!siblingUrl) return;

          const drawerMain = this.querySelector(".quick-cart-drawer__main");
          if (!drawerMain) return;

          try {
            const separator = siblingUrl.includes('?') ? '&' : '?';
            const resp = await fetch(`${siblingUrl}${separator}view=quick-cart`);
            if (!resp.ok) return;
            const html = await resp.text();
            const tmp = document.createElement("DIV");
            tmp.insertAdjacentHTML("beforeend", html);
            const newProduct = tmp.querySelector(".quick-cart-product");
            if (newProduct) {
              drawerMain.innerHTML = "";
              drawerMain.append(newProduct);
              this.bindSiblingColorLinks();
              this.bindSiblingFitLinks();
              this.bindVariantOptionListeners();
            }
          } catch (err) {
            window.location.href = siblingUrl;
          }
        });
      });
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(
        this.querySelectorAll("[data-media-id]")
      ).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      const quickCartDrawer = document.querySelector(".quick-cart-drawer__blocks");
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer");

      if(shopTheLookDrawer && !shopTheLookDrawer.classList.contains("is--open")) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }
      if(!shopTheLookDrawer) {
        document
          .querySelector("body")
          .classList.remove("overflow-hidden");
      }
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();

      if (document.querySelector("card-product-slider.product--open-on-quick-cart")) {
        document.querySelector("card-product-slider.product--open-on-quick-cart").slider.autoplay.start();
        document.querySelector("card-product-slider.product--open-on-quick-cart").classList.remove("product--open-on-quick-cart");
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target
            .closest("button")
            .setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute(
          "aria-expanded",
          true
        );
      } else {
        document
          .querySelectorAll('[aria-controls="quick-cart-drawer"]')
          .forEach(button => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer);
}
